<template lang="pug">
  ul.TheHeaderMenu.menu(itemscope itemtype="https://schema.org/SiteNavigationElement")
    template(
      v-for="menuItem in children",
    )
      TheHeaderMenuItem(
        :key="menuItem.url",
        v-bind="menuItem",
      )
</template>

<script>
import TheHeaderMenuItem from './TheHeaderMenuItem';

export default {
  name: 'TheHeaderMenu',
  components: {
    TheHeaderMenuItem,
  },
  props: {
    children: Array,
  },
};
</script>

<style lang="sass" scoped>
  .menu
    align-items: center
    justify-content: center
    display: flex
    list-style-type: none
</style>
